// Elenco delle news
import React from 'react';
import {get} from './Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import {Message} from "mgUiKit";
import News from './News';
import KeepAlive from './KeepAlive';
import PropTypes from 'prop-types';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TabNewsComponent';

var styles = AppSettings.styles;

class TabNews extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            showLoading: true,
            error: false,
            errorMessage: ""
        }
        this.loadTabNews = this.loadTabNews.bind(this);
    }

    componentDidMount() {
        this.loadTabNews(true);
    }

    getChildContext() {
        return {
            realoadNews: this.loadTabNews
        };
    }

    loadTabNews(loading) {
        this.setState({
            showLoading: loading,
        });

        var url = AppSettings['env'].urlUserBoxTabNews;
        axios.get(url)
            .then(({data, status, statusText}) => {
                if (data.errors.length == 0) {
                    this.setState({
                        data: data,
                        showLoading: false,
                        error: false
                    });
                    // Aggiorno il count sulla toolbar e tab
                    this.context.updateToolbarCount('news', data.countNotification);
                    this.context.updateTabsCount('news', data.countNotification);
                } else {
                    this.setState({
                        showLoading: false,
                        error: true,
                        errorMessage: <KeepAlive />,
                        data: {},
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    showLoading: false,
                    error: true,
                    errorMessage: "",
                    data: {},
                });
            });
    }

    render() {
        var render;
        if(this.state.showLoading){
            render = <CircularProgress style={styles.loadingIcon}/>;
        }
        else{
            if(this.state.error){
                render = <Message align="center">{this.state.errorMessage}</Message>;
            }
            else{
                if (this.state.data.count > 0) {
                    var news = this.state.data.news.map(function (news, i) {
                        return (
                            <News key={news.id} news={news}></News>
                        )
                    });
                    render = news;
                }
                else {
                    render = <Message align="center" type="info">Non hai nuovi messaggi da leggere</Message>;
                }
            }
        }
        return (
            <>
                {render}
            </>
            );
    }
}

TabNews.displayName = componentName;

// PropTypes validation
TabNews.propTypes = {};

// default props
TabNews.defaultProps = {};


TabNews.contextTypes = {
    updateToolbarCount: PropTypes.func,
    updateTabsCount: PropTypes.func
}

// Definizione
TabNews.childContextTypes = {
    realoadNews: PropTypes.func
}

export default  TabNews;